module.exports = __webpack_public_path__ + "img/5.2-环保与可持续性挑战.165b082b.png";